import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, of, shareReplay} from 'rxjs';
import {ITmtLegalEntityOption} from '../interfaces/tmt-erp-outbound-panel.interface';

@Injectable({
  providedIn: 'root'
})
export class TmtErpOutboundLookupService {
  private readonly http = inject(HttpClient);

  private legalEntities$?: Observable<ITmtLegalEntityOption[]>;

  public getLegalEntities(): Observable<ITmtLegalEntityOption[]> {
    this.legalEntities$ ??= this.http.get<ITmtLegalEntityOption[]>('dbov2/legal-entity/many')
      .pipe(
        catchError(() => of<ITmtLegalEntityOption[]>([])),
        shareReplay(1),
      );
    return this.legalEntities$;
  }

  public getLegalEntityNames(): Observable<Map<number, string>> {
    return this.getLegalEntities().pipe(
      map(entities => new Map(entities.map(e => [e.id, e.name]))),
    );
  }
}
